import {override} from 'flarum/common/extend';
import app from 'flarum/forum/app';
import ForumApplication from 'flarum/forum/ForumApplication';

const settingsPrefix = 'kilowhat-custom-paths.';

app.initializers.add('kilowhat-custom-paths', () => {
    // Use override because we need to call our code after boot() to get access to app.forum, but before m.route() is called in mount()
    override(ForumApplication.prototype, 'mount', function (this: ForumApplication, original: any, ...args: any[]) {
        // Default route code adapted from ForumApplication.mount
        // We need to run it before our own code otherwise we wouldn't be able to recognize a route from its old path
        const defaultRoute = app.forum.attribute('defaultRoute');
        let defaultAction = null;

        for (const i in app.routes) {
            if (!app.routes.hasOwnProperty(i)) {
                continue;
            }

            if (app.routes[i].path === defaultRoute) {
                defaultAction = i;
            }
        }

        // Original routes defined in https://github.com/flarum/core/blob/master/js/src/forum/routes.js
        if (app.forum.attribute(settingsPrefix + 'index') && app.routes.index) {
            app.routes.index.path = '/' + app.forum.attribute(settingsPrefix + 'index');
        }

        if (app.forum.attribute(settingsPrefix + 'discussion')) {
            if (app.routes.discussion) {
                app.routes.discussion.path = '/' + app.forum.attribute(settingsPrefix + 'discussion') + '/:id';
            }

            if (app.routes['discussion.near']) {
                app.routes['discussion.near'].path = '/' + app.forum.attribute(settingsPrefix + 'discussion') + '/:id/:near';
            }
        }

        if (app.forum.attribute(settingsPrefix + 'user')) {
            if (app.routes.user) {
                app.routes.user.path = '/' + app.forum.attribute(settingsPrefix + 'user') + '/:username';
            }

            if (app.routes['user.posts']) {
                app.routes['user.posts'].path = '/' + app.forum.attribute(settingsPrefix + 'user') + '/:username';
            }
        }

        if (app.forum.attribute(settingsPrefix + 'user') || app.forum.attribute(settingsPrefix + 'user-discussions')) {
            const prefix = app.forum.attribute(settingsPrefix + 'user') || 'u';
            const filter = app.forum.attribute(settingsPrefix + 'user-discussions') || 'discussions';

            if (app.routes['user.discussions']) {
                app.routes['user.discussions'].path = '/' + prefix + '/:username/' + filter;
            }
        }

        if (app.forum.attribute(settingsPrefix + 'user') || app.forum.attribute(settingsPrefix + 'user-mentions')) {
            const prefix = app.forum.attribute(settingsPrefix + 'user') || 'u';
            const filter = app.forum.attribute(settingsPrefix + 'user-mentions') || 'mentions';

            // Original route defined in https://github.com/flarum/mentions/blob/master/js/src/forum/index.js
            if (app.routes['user.mentions']) {
                app.routes['user.mentions'].path = '/' + prefix + '/:username/' + filter;
            }
        }

        if (app.forum.attribute(settingsPrefix + 'settings') && app.routes.settings) {
            app.routes.settings.path = '/' + app.forum.attribute(settingsPrefix + 'settings');
        }

        if (app.forum.attribute(settingsPrefix + 'notifications') && app.routes.notifications) {
            app.routes.notifications.path = '/' + app.forum.attribute(settingsPrefix + 'notifications');
        }

        // Original routes defined in https://github.com/flarum/tags/blob/master/js/src/forum/index.js
        if (app.forum.attribute(settingsPrefix + 'tags') && app.routes.tags) {
            app.routes.tags.path = '/' + app.forum.attribute(settingsPrefix + 'tags');
        }

        if (app.forum.attribute(settingsPrefix + 'tag') && app.routes.tag) {
            app.routes.tag.path = '/' + app.forum.attribute(settingsPrefix + 'tag') + '/:tags';
        }

        // Original route defined in https://github.com/flarum/subscriptions/blob/master/js/src/forum/index.js
        if (app.forum.attribute(settingsPrefix + 'following') && app.routes.following) {
            app.routes.following.path = '/' + app.forum.attribute(settingsPrefix + 'following');
        }

        // Original route defined in https://github.com/flarum/flags/blob/master/js/src/forum/index.js
        if (app.forum.attribute(settingsPrefix + 'flags') && app.routes.flags) {
            app.routes.flags.path = '/' + app.forum.attribute(settingsPrefix + 'flags');
        }

        // Original routes defined in https://github.com/clarkwinkelmann/flarum-ext-formulaire/blob/master/js/src/forum/index.js
        if (app.forum.attribute(settingsPrefix + 'formulaire-form') && app.routes.formulaireFormShow) {
            app.routes.formulaireFormShow.path = '/' + app.forum.attribute(settingsPrefix + 'formulaire-form') + '/:id';
        }
        if (app.forum.attribute(settingsPrefix + 'formulaire-submission') && app.routes.formulaireSubmission) {
            app.routes.formulaireSubmission.path = '/' + app.forum.attribute(settingsPrefix + 'formulaire-submission') + '/:id';
        }

        // Original route defined in https://github.com/FriendsOfFlarum/user-directory/blob/master/js/src/forum/index.js
        if (app.forum.attribute(settingsPrefix + 'fof-user-directory') && app.routes.fof_user_directory) {
            app.routes.fof_user_directory.path = '/' + app.forum.attribute(settingsPrefix + 'fof-user-directory');
        }

        // Original route defined in https://github.com/FriendsOfFlarum/pages/blob/master/js/src/forum/index.js
        if (app.forum.attribute(settingsPrefix + 'fof-pages') && app.routes.page) {
            app.routes.page.path = '/' + app.forum.attribute(settingsPrefix + 'fof-pages') + '/:id';
        }

        // Original route defined in https://github.com/FriendsOfFlarum/gamification/blob/master/js/src/forum/index.js
        if (app.forum.attribute(settingsPrefix + 'fof-gamification') && app.routes.rankings) {
            app.routes.rankings.path = '/' + app.forum.attribute(settingsPrefix + 'fof-gamification');
        }

        // Original routes defined in https://github.com/FriendsOfFlarum/byobu/blob/master/js/src/forum/pages/routes.js
        if (app.forum.attribute(settingsPrefix + 'fof-byobu') && app.routes.byobuPrivate) {
            app.routes.byobuPrivate.path = '/' + app.forum.attribute(settingsPrefix + 'fof-byobu');
        }
        if (app.forum.attribute(settingsPrefix + 'user') || app.forum.attribute(settingsPrefix + 'fof-byobu-profile')) {
            const prefix = app.forum.attribute(settingsPrefix + 'user') || 'u';
            const filter = app.forum.attribute(settingsPrefix + 'fof-byobu-profile') || 'private';

            if (app.routes.byobuUserPrivate) {
                app.routes.byobuUserPrivate.path = '/' + prefix + '/:username/' + filter;
            }
        }

        // Original route defined in https://github.com/askvortsov1/flarum-categories/blob/master/js/src/forum/index.js
        if (app.forum.attribute(settingsPrefix + 'askvortsov-categories') && app.routes.categories) {
            app.routes.categories.path = '/' + app.forum.attribute(settingsPrefix + 'askvortsov-categories');
        }

        // Original routes defined in https://github.com/v17development/flarum-blog/blob/master/js/src/forum/index.js
        if (app.forum.attribute(settingsPrefix + 'v17development-blog-overview') && app.routes.blog) {
            app.routes.blog.path = '/' + app.forum.attribute(settingsPrefix + 'v17development-blog-overview');
        }
        if (app.forum.attribute(settingsPrefix + 'v17development-blog-compose') && app.routes.blogComposer) {
            app.routes.blogComposer.path = '/' + app.forum.attribute(settingsPrefix + 'v17development-blog-compose');
        }
        if (app.forum.attribute(settingsPrefix + 'v17development-blog-category') && app.routes.blogCategory) {
            app.routes.blogCategory.path = '/' + app.forum.attribute(settingsPrefix + 'v17development-blog-category') + '/:slug';
        }
        if (app.forum.attribute(settingsPrefix + 'v17development-blog-post')) {
            if (app.routes.blogArticle) {
                app.routes.blogArticle.path = '/' + app.forum.attribute(settingsPrefix + 'v17development-blog-post') + '/:id';
            }
            if (app.routes['blogArticle.near']) {
                app.routes['blogArticle.near'].path = '/' + app.forum.attribute(settingsPrefix + 'v17development-blog-post') + '/:id/:near';
            }
        }

        // Original routes defined in https://github.com/flamarkt/core/blob/main/js/src/forum/routes.ts
        if (app.forum.attribute(settingsPrefix + 'flamarkt-cart') && app.routes['flamarkt.cart']) {
            app.routes['flamarkt.cart'].path = '/' + app.forum.attribute(settingsPrefix + 'flamarkt-cart');
        }
        if (app.forum.attribute(settingsPrefix + 'flamarkt-account') && app.routes['flamarkt.account']) {
            app.routes['flamarkt.account'].path = '/' + app.forum.attribute(settingsPrefix + 'flamarkt-account');
        }
        if (app.forum.attribute(settingsPrefix + 'flamarkt-orders') && app.routes['flamarkt.account.orders']) {
            app.routes['flamarkt.account.orders'].path = '/' + app.forum.attribute(settingsPrefix + 'flamarkt-orders');
        }
        if (app.forum.attribute(settingsPrefix + 'flamarkt-order') && app.routes['flamarkt.orders.show']) {
            app.routes['flamarkt.orders.show'].path = '/' + app.forum.attribute(settingsPrefix + 'flamarkt-order') + '/:id';
        }
        if (app.forum.attribute(settingsPrefix + 'flamarkt-products') && app.routes['flamarkt.products.index']) {
            app.routes['flamarkt.products.index'].path = '/' + app.forum.attribute(settingsPrefix + 'flamarkt-products');
        }
        if (app.forum.attribute(settingsPrefix + 'flamarkt-product') && app.routes['flamarkt.products.show']) {
            app.routes['flamarkt.products.show'].path = '/' + app.forum.attribute(settingsPrefix + 'flamarkt-product') + '/:id';
        }

        // Original route defined in https://github.com/flamarkt/balance/blob/main/js/src/forum/index.ts
        if (app.forum.attribute(settingsPrefix + 'flamarkt-balance') && app.routes['flamarkt.account.balance']) {
            app.routes['flamarkt.account.balance'].path = '/' + app.forum.attribute(settingsPrefix + 'flamarkt-balance');
        }

        // Original routes defined in https://github.com/flamarkt/categories/blob/main/js/src/forum/index.ts
        if (app.forum.attribute(settingsPrefix + 'flamarkt-categories') && app.routes['flamarkt.categories.index']) {
            app.routes['flamarkt.categories.index'].path = '/' + app.forum.attribute(settingsPrefix + 'flamarkt-categories');
        }
        if (app.forum.attribute(settingsPrefix + 'flamarkt-category') && app.routes['flamarkt.categories.show']) {
            app.routes['flamarkt.categories.show'].path = '/' + app.forum.attribute(settingsPrefix + 'flamarkt-category') + '/:id';
        }

        // Original route defined in https://github.com/flamarkt/identity/blob/main/js/src/forum/index.ts
        if (app.forum.attribute(settingsPrefix + 'flamarkt-identity') && app.routes['flamarkt.account.identity']) {
            app.routes['flamarkt.account.identity'].path = '/' + app.forum.attribute(settingsPrefix + 'flamarkt-identity');
        }

        // Original route defined in https://github.com/flamarkt/signup-page/blob/main/js/src/forum/index.ts
        if (app.forum.attribute(settingsPrefix + 'flamarkt-signup') && app.routes['flamarkt.signup']) {
            app.routes['flamarkt.signup'].path = '/' + app.forum.attribute(settingsPrefix + 'flamarkt-signup');
        }

        // Original route defined in https://github.com/clarkwinkelmann/flarum-ext-group-list/blob/master/js/src/forum/index.js
        if (app.forum.attribute(settingsPrefix + 'clarkwinkelmann-group-list') && app.routes['clarkwinkelmann-group-list']) {
            app.routes['clarkwinkelmann-group-list'].path = '/' + app.forum.attribute(settingsPrefix + 'clarkwinkelmann-group-list');
        }

        // Replace the default route path with the overridden path
        // So that the original app.mount can use the updated value
        app.forum.pushAttributes({
            defaultRoute: app.routes[defaultAction].path,
        });

        original.call(this, ...args);
    });
}, -100);
